import React from 'react';
import { useNavigate, useParams } from "react-router-dom";
import styles from './varifiedPage.module.css';

export default function VarifiedPage({ onContinue, onCancel }) {
  const navigate = useNavigate();
const { userId, deviceUuid } = useParams();
    
    const basePath =
        userId && deviceUuid
            ? `/${userId}/${deviceUuid}`
            : "";
    
    const goTo = (path) => {
        navigate(
            basePath
                ? `${basePath}${path}`
                : path
        );
    };
  /* =====================================================
     CONTINUE
  ====================================================== */

  const handleContinue = () => {
    /*
      If parent component provides onContinue,
      use it first.
    */
    if (onContinue) {
      onContinue();
      return;
    }

    /*
      Default navigation
    */
    goTo('/partnerhome');
  };

  /* =====================================================
     CANCEL
  ====================================================== */

  const handleCancel = () => {
    /*
      If parent component provides onCancel,
      use it first.
    */
    if (onCancel) {
      onCancel();
      return;
    }

    /*
      Default navigation.
      Change this route if your actual
      previous page is different.
    */
    goTo('/bankvari');
  };

  /* =====================================================
     RENDER
  ====================================================== */

  return (
    <div className={styles.screenWrapper}>

      <div className={styles.deviceFrame}>

        <div className={styles.scrollContainer}>

          {/* =================================================
              MAIN CONTENT
          ================================================== */}

          <main className={styles.contentSection}>

            {/* =================================================
                SUCCESS ICON
            ================================================== */}

            <div
              className={styles.iconContainer}
              aria-label="Verification submitted"
            >

              <div className={styles.outerRing}>

                <div className={styles.middleRing}>

                  <div className={styles.innerCircle}>

                    <svg
                      width="42"
                      height="42"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ffffff"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >

                      <polyline
                        points="20 6 9 17 4 12"
                      />

                    </svg>

                  </div>

                </div>

              </div>

            </div>

            {/* =================================================
                TITLE
            ================================================== */}

            <h1 className={styles.title}>
              Forwarded for Verification
            </h1>

            {/* =================================================
                DESCRIPTION
            ================================================== */}

            <p className={styles.subtitle}>
              You will get an email once your documents
              have been approved.
              <br />
              We appreciate your patience.
            </p>

          </main>

          {/* =================================================
              FOOTER ACTIONS
          ================================================== */}

          <footer className={styles.actionFooter}>

            {/* =================================================
                CONTINUE
            ================================================== */}

            <button
              type="button"
              className={styles.continueBtn}
              onClick={handleContinue}
            >
              Continue
            </button>

            {/* =================================================
                CANCEL
            ================================================== */}

            <button
              type="button"
              className={styles.cancelBtn}
              onClick={handleCancel}
            >
              Cancel
            </button>

          </footer>

        </div>

      </div>

    </div>
  );
}